import axios from 'axios'
import { wrapper } from '@/store'
import { NOT_VERIFIED } from './constants'

const getServerSidePropsCatch = (
  error: unknown,
  context?: Parameters<ReturnType<typeof wrapper.getServerSideProps>>[0]
) => {
  if (axios.isAxiosError(error)) {
    const statusCode = String(error.response?.status)
    if (context?.query?.from === 'monitor') {
      return {
        props: {
          errorCode: '405',
          message: error?.data?.errors?.messages || error?.data?.msg || error?.message || ''
        }
      }
    }
    if (['403', '404', '500'].includes(statusCode)) {
      return {
        props: {
          errorCode: statusCode,
          message: error?.data?.errors?.messages || error?.data?.msg || error?.message || ''
        }
      }
    } else if (statusCode === '401') {
      return {
        redirect: {
          destination: `/login`,
          permanent: false
        }
      }
    }
  } else {
    const code = error?.data?.code

    if ([NOT_VERIFIED].includes(code)) {
      return {
        redirect: {
          destination: '/not-verified',
          permanent: false
        }
      }
    }
  }

  return {
    props: {
      errorCode: '500',
      message: error?.data?.errors?.messages || error?.data?.msg || error?.message || ''
    }
  }
}

export default getServerSidePropsCatch
